'use client';

import { c as _c } from "react/compiler-runtime";
import type { ProductCard } from '@repo/shopify';
import { ProductCardClient } from './product-card-client';
interface ProductGridClientProps {
  products: ProductCard[];
  columns?: 2 | 3 | 4;
  showQuickAdd?: boolean;
  priorityImageCount?: number;
  enableReviews?: boolean;
  moneyLocale?: string;
  ratings?: (number | null)[];
  reviewCounts?: (number | null)[];
}
const columnClasses = {
  2: 'grid-cols-2',
  3: 'grid-cols-2 md:grid-cols-3',
  4: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
};
function Bone(t0) {
  const $ = _c(2);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `animate-pulse rounded bg-neutral-200 ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <div className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
}
function ProductCardSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative aspect-[3/4] overflow-hidden rounded bg-neutral-100"><Bone className="absolute inset-0" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="group relative">{t0}<div className="mt-3"><Bone className="h-4 w-10" /><Bone className="mt-2 h-4 w-3/4" /><Bone className="mt-2 h-4 w-16" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function ProductGridSkeleton(t0) {
  const $ = _c(5);
  const {
    columns: t1,
    count: t2
  } = t0;
  const columns = t1 === undefined ? 4 : t1;
  const count = t2 === undefined ? 8 : t2;
  const t3 = `grid ${columnClasses[columns]} gap-4 md:gap-6`;
  let t4;
  if ($[0] !== count) {
    t4 = Array.from({
      length: count
    }, _temp).map(_temp2);
    $[0] = count;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}
function _temp2(key) {
  return <ProductCardSkeleton key={key} />;
}
function _temp(_, index) {
  return `product-skel-${index}`;
}
export function ProductGridClient(t0) {
  const $ = _c(19);
  const {
    products,
    columns: t1,
    showQuickAdd: t2,
    priorityImageCount: t3,
    enableReviews: t4,
    moneyLocale,
    ratings,
    reviewCounts
  } = t0;
  const columns = t1 === undefined ? 4 : t1;
  const showQuickAdd = t2 === undefined ? true : t2;
  const priorityImageCount = t3 === undefined ? 0 : t3;
  const enableReviews = t4 === undefined ? false : t4;
  if (products.length === 0) {
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="py-20 text-center"><p className="text-lg text-neutral-500">No products found.</p></div>;
      $[0] = t5;
    } else {
      t5 = $[0];
    }
    return t5;
  }
  const t5 = `grid ${columnClasses[columns]} gap-4 md:gap-6`;
  let t6;
  if ($[1] !== enableReviews || $[2] !== moneyLocale || $[3] !== priorityImageCount || $[4] !== products || $[5] !== ratings || $[6] !== reviewCounts || $[7] !== showQuickAdd) {
    let t7;
    if ($[9] !== enableReviews || $[10] !== moneyLocale || $[11] !== priorityImageCount || $[12] !== ratings || $[13] !== reviewCounts || $[14] !== showQuickAdd) {
      t7 = (product, index) => <ProductCardClient key={product.id} product={product} showQuickAdd={showQuickAdd} preloadPrimaryImage={index < priorityImageCount} enableReviews={enableReviews} moneyLocale={moneyLocale} rating={ratings?.[index] ?? undefined} reviewCount={reviewCounts?.[index] ?? undefined} />;
      $[9] = enableReviews;
      $[10] = moneyLocale;
      $[11] = priorityImageCount;
      $[12] = ratings;
      $[13] = reviewCounts;
      $[14] = showQuickAdd;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = products.map(t7);
    $[1] = enableReviews;
    $[2] = moneyLocale;
    $[3] = priorityImageCount;
    $[4] = products;
    $[5] = ratings;
    $[6] = reviewCounts;
    $[7] = showQuickAdd;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}